export default function SpineCard({ spine }) {
  const rows = [
    ['Famille',         spine.famille         || '—'],
    ['Régime · TMI',    spine.regime_tmi      || '—'],
    ['Patrimoine net',  spine.patrimoine_net  || '—'],
    ['Profil · Horizon',spine.profil_horizon  || '—'],
  ]
  return (
    <div className="rounded-xl border border-line bg-white p-4">
      <div className="mb-3 text-[10px] font-semibold uppercase tracking-[1.6px] text-fiscal-fg">
        Contexte client
      </div>
      <dl className="grid grid-cols-2 gap-x-4 gap-y-2 md:block md:space-y-0">
        {rows.map(([k, v], i) => (
          <div key={k} className={`flex items-baseline justify-between text-[12px] md:py-2 ${i < rows.length - 1 ? 'md:border-b md:border-line/60' : ''}`}>
            <dt className="text-muted">{k}</dt>
            <dd className="max-w-[60%] text-right text-[13px] font-semibold">{v}</dd>
          </div>
        ))}
      </dl>
    </div>
  )
}
